export default __webpack_public_path__ + "static/media/img3.4ed17c40.png";